import { call, put } from 'redux-saga/effects';
import { AxiosResponse, AxiosError } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { GetIntegrationTriggers, saveIntegrationTrigger } from './index';

// Api's
import { integrationTriggerApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getIntegrationTriggerSaga(action: GetIntegrationTriggers) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      integrationTriggerApi.getDomain
    );
    if (response.data.result) {
      yield put(saveIntegrationTrigger(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);
      yield put(saveIntegrationTrigger(null, true, resultError.messagesDataError));
    }
  }
}
